import { render } from "./StudentRequirementSubmissionDataTable.vue?vue&type=template&id=67b02ac9&scoped=true"
import script from "./StudentRequirementSubmissionDataTable.vue?vue&type=script&lang=js"
export * from "./StudentRequirementSubmissionDataTable.vue?vue&type=script&lang=js"

import "./StudentRequirementSubmissionDataTable.vue?vue&type=style&index=0&id=67b02ac9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b02ac9"]])

export default __exports__